import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { apiBaseUrl, apiRoots } from 'src/config';
import { TaskBaseApi } from './task-base.api';
import { TaskBase, TaskMapper } from './task-base.model';

export interface MachineTaskInfo extends TaskBase {
  /**
   * The machine this task belongs to.
   */
  machineId: string;
  /**
   * Functionally grouping the components.
   */
  functionGroup?: string;
  /**
   * Groups a task into a component.
   */
  component?: string;
  /**
   * Required tooling.
   */
  requiredTooling?: string;
  /**
   * Possible spare parts.
   */
  possibleSpareParts?: string;
}

const baseUrl = apiBaseUrl + apiRoots.machineTask;

@Injectable()
export class MachineTaskApi extends TaskBaseApi<MachineTaskInfo> {
  constructor() {
    const http = inject(HttpClient);

    super(http, baseUrl);
  }

  /**
   * Gets all tasks related to a machine.
   */
  tasksByMachine$(machineId: string) {
    return this.http
      .get<MachineTaskInfo[]>(`${apiBaseUrl}${apiRoots.machineOverview}/tasksbyasset/${machineId}`)
      .pipe(map((tasks) => tasks.map((task) => TaskMapper.mapFromBackend(task))));
  }
}
